<template lang="pug">
  article.LearningCenterSingle.learning-single
    PostContent(
      :post-data="data"
      show-thumbnail-category
      subscribe
      has-tags
    )
</template>

<script>
import PostContent from 'Components/PostContent/PostContent';
import { LearnPostClass } from '../classes';

export default {
  name: 'LearningCenterSingle',
  components: {
    PostContent,
  },
  props: {
    data: {
      required: true,
      type: LearnPostClass,
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
